import { LoadingState } from '../../../types/loading-state';
import { createFetchedData } from '../../../utils/fetched-data/create-fetched-data';
import { defaultMemberJourneysState } from '../types/member-journeys-state';
export const defaultTemporaryLoyaltyDomainState = {
    isMemberSignedIn: false,
    member: createFetchedData(LoadingState.NotLoaded),
    memberJourneys: defaultMemberJourneysState,
    memberPaymentCards: createFetchedData(LoadingState.NotLoaded),
    memberTicketRedemptionCards: createFetchedData(LoadingState.NotLoaded),
    memberTransactions: createFetchedData(LoadingState.NotLoaded),
    memberWatchedFilmsByYear: {}
};
